import { Helmet } from 'react-helmet-async';
import type { BlogPost } from '@/types/blog';
import { SITE_ORIGIN } from '@/lib/seo/site-url';
import { PERSON_ID } from '@/lib/seo/metadata';

interface JsonLdProps {
  data?: Record<string, unknown>;
  post?: BlogPost;
  baseUrl?: string;
}

export function JsonLd({ data, post, baseUrl = SITE_ORIGIN }: JsonLdProps) {
  // Se post foi fornecido, gerar schema BlogPosting
  const schema = post ? {
    '@context': 'https://schema.org',
    '@type': post.schema?.type || 'BlogPosting',
    headline: post.title,
    description: post.excerpt,
    image: post.coverImage.startsWith('http') 
      ? post.coverImage 
      : `${baseUrl}${post.coverImage}`,
    datePublished: post.date.toISOString(),
    dateModified: (post.lastModified || post.date).toISOString(),
    // Autor padrão é a mesma entidade do Person do site (e da Geniaria, via sameAs).
    author: post.schema?.author && post.schema.author !== 'Johnny Vaz'
      ? { '@type': 'Person', name: post.schema.author }
      : { '@type': 'Person', '@id': PERSON_ID, name: 'Johnny Vaz', url: baseUrl },
    publisher: {
      '@type': 'Organization',
      name: post.schema?.publisher || 'Johnny Vaz',
      logo: {
        '@type': 'ImageObject',
        url: `${baseUrl}/images/logo/logo-jv-tree.png`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${baseUrl}${post.url}`,
    },
    keywords: post.tags?.join(', ') || post.categories.join(', '),
    articleSection: post.categories.join(', '),
    inLanguage: post.agentMetadata?.lang || 'pt-BR',
    timeRequired: `PT${post.readingTime}M`,
  } : data;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
